import * as React from "react";

import { useAppSelector } from "../../redux/hooks";
import { Divider } from ".";
import { signOut } from "../../services/SecurityService";
import { Link, useHistory } from "react-router-dom";

interface Props {
  src?: string;
  size?: number;
  iconLetter?: string;
  color?: string;
  isLoggedUser?: boolean;
}

const UserAvatar: React.FC<Props> = ({
  src,
  size,
  iconLetter,
  color,
  isLoggedUser,
}) => {
  const [visibleMenu, setVisibleMenu] = React.useState(false);
  function toggleMenu() {
    if (isLoggedUser) setVisibleMenu(!visibleMenu);
  }
  const style: React.CSSProperties = {
    height: `${size}rem`,
    width: `${size}rem`,
  };
  const styleNoImage: React.CSSProperties = {
    backgroundColor: color ? color : "#5B99E4",
    height: `${size}rem`,
    width: `${size}rem`,
  };
  const styleIconLetter: React.CSSProperties = {
    fontSize: size ? `${size * 0.5}rem` : "1rem",
  };
  const user = useAppSelector((state) => state.UserSlice.user);
  const history = useHistory()


  const handleSignOut = () => {
    signOut()
    history.push("/")
  }

  return (
    <div className="user-utils">
      {src ? (
        <div className="cursor-pointer" onClick={toggleMenu}>
          <img src={src} alt="" className="user-avatar " style={style} />
        </div>
      ) : (
        <div
          style={styleNoImage}
          className="user-avatar-no-src cursor-pointer"
          onClick={toggleMenu}
        >
          <p
            style={styleIconLetter}
            className="text-light noselect-text text-uppercase mb-0"
          >
            {iconLetter}
          </p>
        </div>
      )}
      {visibleMenu && (
        <div>
          <div className="drop-down-background" onClick={toggleMenu} />

          <div className="drop-down-menu">

            <Link to={"/edit-profile"} className="text-decoration-none dropdown-header text-light">Edit Profile</Link>
            {/* <Divider /> */}
            <p className="dropdown-header text-light">{user.email}</p>
            <Divider />
            <p
              className="text-light my-2 ps-4 cursor-pointer drop-down-menu-buttons"
              onClick={handleSignOut}
            >
              Sign Out
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
